// antd v5 兼容 React 19 官方补丁：修复静态方法（Modal.confirm/message/notification）
// 与 Wave 动效在 React 19 下的渲染问题，并消除 "[antd: compatible]" 警告。
// 必须在 antd 被使用之前引入，故置于入口文件首行。
import '@ant-design/v5-patch-for-react-19';
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <App />
  // </StrictMode>,
)
